import BasicList from 'core/modules/components/lists/components/BasicList/BasicList';
import LicenseItem from 'core/modules/components/lists/licenses/LicenseItem/LicenseItem';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';

/**
 * LicensesList - Lista de licencias con scroll infinito. Envuelve el genérico v2
 * `BasicList` (semántica `<ul>/<li>` accesible) y renderiza un `LicenseItem` por licencia.
 */

// `LicenseItem` es JS y va envuelto en `withTranslation` (props sin tipar): se aliasa a un
// componente permisivo para poder inyectar las props de dominio de cada licencia por spread.
const LicenseItemRow = LicenseItem as unknown as React.FC<Record<string, unknown>>;

export type License = Readonly<{ guid?: string }> & Record<string, unknown>;

type LicensesListProps = Readonly<{
  configProgramPicture?: boolean;
  hasMore?: boolean;
  licenses?: License[];
  loadMore?: () => void;
  onClickView?: (license: License) => void;
  onDelete?: (license: License) => void;
  typeView?: 'default' | 'simple';
}>;

function LicensesList({
  configProgramPicture,
  hasMore,
  licenses = [],
  loadMore,
  onClickView = () => {},
  onDelete,
  typeView = 'default',
}: LicensesListProps): JSX.Element {
  return (
    <div className="licenses-list">
      <InfiniteScroll pageStart={0} loadMore={loadMore} hasMore={hasMore}>
        <BasicList
          items={licenses.map((item, index) => (
            <LicenseItemRow
              key={item.guid ?? index}
              {...item}
              configProgramPicture={configProgramPicture}
              onClickView={() => onClickView(item)}
              onDelete={onDelete ? () => onDelete(item) : null}
              typeView={typeView}
            />
          ))}
        />
      </InfiniteScroll>
    </div>
  );
}

export default LicensesList;
